import { AvailableMedicalService } from '../../models/Entities/MedicalServices/AvailableMedicalService';
import { ErrorType } from '../../models/HttpError';
import { CommonState } from '../common/state/commonState';

export interface AvailableMedicalServiceState
  extends CommonState<AvailableMedicalService> {
  // update all
  isUpdatingAll: boolean;
  isUpdatingAllSuccess: undefined | boolean;
  FailUpdatingAll: boolean;

  // Changing status
  isChangingStatus: boolean;
  successChangingStatus: boolean | undefined;
  failOnChangingStatus: boolean;

  // Specialties
  isLoadingSpecialties: boolean;
  failOnLoadingSpecialties: boolean;
  isAddingSpecialty: boolean;
  failOnAddingSpecialty: boolean;
  isRemovingSpecialty: boolean;
  failOnRemovingSpecialty: boolean;
  errorSpecialties: ErrorType | undefined;
}

export const AvailableMedicalServicesUnloadState: any = {
  // loading all
  isLoadingAll: false,
  isLoadingAllSuccess: undefined,
  FailGettingAll: false,

  // update all
  isUpdatingAll: false,
  isUpdatingAllSuccess: undefined,
  FailUpdatingAll: false,

  // loading one
  isLoadingOne: false,
  isLoadingOneSuccess: undefined,
  FailGettingOne: false,

  // saving
  isSaving: false,
  isSavingSuccess: undefined,
  FailSaving: false,

  // adding
  isAdding: false,
  isAddingSuccess: undefined,
  FailAdding: false,

  isFiltered: false,
  filterCriteria: undefined,

  // changing status
  isChangingStatus: false,
  isChangingStatusSuccess: undefined,
  FailChangingStatus: false,

  // specialties
  isLoadingSpecialties: false,
  failOnLoadingSpecialties: false,
  isAddingSpecialty: false,
  failOnAddingSpecialty: false,
  isRemovingSpecialty: false,
  failOnRemovingSpecialty: false,
  errorSpecialties: undefined,

  list: [],
  Selected: undefined,
  Error: undefined
};
